import withOverlaysContext from "Components/overlaysContext/withOverlaysContext";
import withOverlaysProvider from "Components/overlaysContext/withOverlaysProvider";
import isNil from "lodash/isNil";
import React, { memo, useMemo } from "react";
import { withResizeDetector } from "react-resize-detector";
import ScrollbarsInner from "./scrollbars.inner";
function Scrollbars(props) {
    const Result = useMemo(() => (!isNil(props.height) ? ScrollbarsInner : withResizeDetector(ScrollbarsInner)), [props.height]);
    return React.createElement(Result, { ...props });
}
Scrollbars.defaultProps = {
    showScrollbar: "onHover"
};
Scrollbars.displayName = "Scrollbars";
const ScrollbarsWithOverlaysProvider = memo(withOverlaysProvider(withOverlaysContext(Scrollbars)));
ScrollbarsWithOverlaysProvider.displayName = "ScrollbarsWithOverlaysProvider";
export default ScrollbarsWithOverlaysProvider;
